module.exports = __webpack_public_path__ + "static/media/drop-down-arrow.bfc53b6a.svg";